// FTEDN Team — Error fallback UI
import './ErrorFallback.css';

interface Props {
  error: Error;
  resetError: () => void;
}

export function ErrorFallback({ error, resetError }: Props) {
  return (
    <div className="error-fallback">
      <div className="error-fallback-card">
        <span className="error-fallback-icon">⚠️</span>
        <h1 className="error-fallback-title">Something went wrong</h1>
        <p className="error-fallback-message">
          We've been notified and are looking into it. Please try refreshing.
        </p>
        {import.meta.env.DEV && (
          <details className="error-fallback-details">
            <summary>Error details (dev only)</summary>
            <pre>{error.message}</pre>
          </details>
        )}
        <div className="error-fallback-actions">
          <button className="error-fallback-btn primary" onClick={resetError}>Try Again</button>
          <button className="error-fallback-btn" onClick={() => window.location.href = '/'}>Go Home</button>
        </div>
      </div>
    </div>
  );
}
